import { PDFDocument } from "pdf-lib";
import { stampCpFields } from "./cpStamp";
import { stampSignatureImage } from "./signatureStamp";

// ENG-1865: one agreement's PDF, stamped in the single CP page's order: the signature, then the fields. Without a signature it's the preview.
export async function buildCpPdf({ pdfBytes, signImageUrl, signatureFields, cpFields, typed }) {
  const pdfDoc = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
  if (signImageUrl) await stampSignatureImage(pdfDoc, signImageUrl, signatureFields);
  await stampCpFields(pdfDoc, cpFields, typed);
  return pdfDoc.save();
}
